import { combineReducers } from 'redux'
import data from './data/slice'

const userReducer = combineReducers({
  data,
})

export default userReducer
